export default __webpack_public_path__ + "static/media/4.22dee1b9.jpg";